import { render } from "./BuscarProductoMostradorPage.vue?vue&type=template&id=df285b3e&scoped=true"
import script from "./BuscarProductoMostradorPage.vue?vue&type=script&lang=js"
export * from "./BuscarProductoMostradorPage.vue?vue&type=script&lang=js"

import "./BuscarProductoMostradorPage.vue?vue&type=style&index=0&id=df285b3e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df285b3e"]])

export default __exports__